module.exports = __webpack_public_path__ + "media/images/photo/top/plan/plan3-2fdee1e4c6bcf87df70fc54f8774a58b.jpg";